import {BindWalletParam, ModalWithHeaderProps} from "../../types/types";
import {ModalWithHeader} from "../../ui/Modal";
import React, {useEffect, useMemo, useState} from "react";
import {getWalletInitApi, getWalletNonceApi, loginByWalletApi, toBindWalletApi} from "../../api";
import {isSuccess} from "../../api/request";
import matchlog from "../../utils/matchlog";
import {useMatch} from "../../MatchContext";
import eventManager from "../../hooks/eventManager";
import {useIntl} from "react-intl";
import WalletModalContent from "../WalletModalContent";
import {useBTCWallet} from "../../hooks/useBTCWallet";
import {RecommendItem} from "../LoginBox";
import {LeatherIcon, PhantomIcon, UnisatIcon, XverseIcon} from "../../assets/icon";
import {useDownMd} from "../../hooks/useLayout";
import {Button} from "../index";
type BTCConnectModalProps = ModalWithHeaderProps & {
    type?: 'login' | 'bind' | ''
    onSuccess?: () => void
}
function BTCConnectModal({
                                     type = 'login',
                                     onSuccess,
                                     ...props
                                 }: BTCConnectModalProps) {
    const isDownMd = useDownMd()
    const intl = useIntl()
    const {wallets, installedWallets, chooseWallet, wallet, address, onConnect} = useBTCWallet()
    const iconMaps = {
        leather: <LeatherIcon size={isDownMd ? 36 : 40}/>,
        unisat: <UnisatIcon size={isDownMd ? 36 : 40}/>,
        xverse: <XverseIcon size={isDownMd ? 36 : 40}/>,
        phantom:<PhantomIcon size={isDownMd ? 36 : 40}/>,
    }

    const {events, login} = useMatch()
    const [status, setStatus] = useState<'' | 'nonce' | 'signer' | 'success' | 'error'>('')
    const statusRef = React.useRef(status)
    const [error, setError] = useState('')
    const connected = useMemo(() => {
        return !!address
    }, [address])
    const disconnect = async () => {
        wallet&& wallet.disconnet &&wallet!.disconnet!()
        setStatus('')
        chooseWallet(null)
        statusRef.current = ''
        setError('')
    }

    const toLoginInWallet = async () => {
        if (statusRef.current || !address || !wallet) return
        try {
            setStatus('nonce')
            statusRef.current = 'nonce'
            const res = type == 'bind' ? await getWalletInitApi({address,type:"BTC"}) : await getWalletNonceApi({address,type:"BTC"});
            if (!isSuccess(res)) {
                throw new Error(res.message)
            }
            const nonce = res.code >= 0 ? res.data.nonce : null;
            if (nonce) {
                setStatus('signer')
                statusRef.current = 'signer'
                const message = "By signing, you are proving you own this wallet and logging in. This does not initiate a transaction or cost any fees.Nonce:" + res.data.nonce;
                const signedMessage = await wallet.signMessage(message);
                let obj: BindWalletParam = {
                    type: 'BTC',
                    address: address,
                    signature: signedMessage,
                    message: message,
                    connector_type: 'BTC',
                    wallet_client_type: wallet.walletKey
                }
                const res1 = type == 'bind' ? await toBindWalletApi(obj) : await loginByWalletApi(obj)
                if (res1) {
                    if (!isSuccess(res1)) {
                        throw new Error(res1.message)
                    }
                    matchlog.log(res1)
                    setStatus('success')
                    statusRef.current = 'success'
                    if (type == 'bind') {
                        events!.onBind && events!.onBind({
                            type: 'btc'
                        })
                        eventManager.emit('onBind', {
                            type: 'btc'
                        })
                    } else {
                        await login({
                            // mid: res1.data.mid,
                            token: `${res1.data.token_type} ${res1.data.access_token}`
                        })
                    }
                    onSuccess && onSuccess()
                }
            }
        } catch (error: any) {
            // toast.error(error.message)
            // disconnect()
            console.error('btc error',error)
            setStatus('error')
            setError(error.message)
            statusRef.current = ''
        }
    }

    useEffect(() => {
        if (wallet) {
            console.log('onConnect')
            try{
                onConnect()
            }catch(err:any){
                setStatus('error')
                setError(err.message)
            }
        } else {
            setStatus('')
        }
    }, [wallet]);

    useEffect(() => {
        if (address) {
            toLoginInWallet()
        }
    }, [address]);

    useEffect(() => {
        if (!props.isOpen) {
            disconnect()
        }
    }, [props.isOpen]);

    const onBack = ()=>{
        wallet&& wallet.disconnet &&wallet!.disconnet!()
        setStatus('')
        chooseWallet(null)
        statusRef.current = ''
        setError('')
    }

    return <ModalWithHeader {...props} title={props.title || (intl.formatMessage({
        id: type == "bind" ? "bindWith" : "loginWith"
    }, {
        name: "BTC"
    }))} onBack={wallet ? onBack: undefined}>
        {
            wallet ? <WalletModalContent error={error} setError={setError} status={status} disconnect={disconnect}
                                         address={address || ''} connected={connected} visible setVisible={() => {
            }}/> : <div className="matchid-login-box">
                <div className="matchid-login-recommend-list">
                    {
                        installedWallets.map(wallet => {
                            return <RecommendItem
                                key={wallet.walletKey}
                                icon={iconMaps[wallet.walletKey as keyof typeof iconMaps]}
                                name={wallet.name} onClick={() => {
                                chooseWallet(wallet)
                            }}/>
                        })
                    }
                    {
                        wallets.filter(wallet => !installedWallets.find(installedWallet => installedWallet.walletKey == wallet.walletKey)).map(wallet => {
                            return <RecommendItem key={wallet.walletKey}
                                                  icon={iconMaps[wallet.walletKey as keyof typeof iconMaps]}
                                                  name={wallet.name} onClick={() => {
                            }}
                                                  footer={<Button size="sm" onClick={() => {
                                                      window.open(wallet.website)
                                                  }}>Install</Button>}/>
                        })
                    }


                </div>
            </div>
        }
    </ModalWithHeader>
}

export default function BTCModal(props: BTCConnectModalProps) {
    return props.isOpen && <BTCConnectModal {...props}/>
}